<template>
	<sf-data-table
		ref="dataTable"
		:pageUnit="pageUnit_"
		:totalSize="totalSize_"
		paging
		:columns="columns"
		:rows="rows"
		:addRowData="addRowData"
		selection
		creatable
		editable
		:saveFunc="saveFunc"
		@changedPage="changedPage"
		@row-click="rowClick"
		index
	>
		<template v-slot:customRows="slotProps">
			<template v-if="slotProps.column.property === 'testTime'">
				<template v-if="slotProps.row.rowType && slotProps.row.rowType === 'add'">
					<el-time-picker v-model="slotProps.row[slotProps.column.property]" maxlength="6" />
				</template>
				<template v-else>
					<span @click="() => onClick(slotProps.row)" :style="{ color: 'orange', fontWeight: 'bold', cursor: 'pointer' }">
						{{ slotProps.row.testTime }}
					</span>
				</template>
			</template>
		</template>
		<template v-slot:actionsLeft>
			<sf-button v-if="isButton_(scrId, 'AD')" line icon="square-plue" :onClick="addAction">
				{{ getMessage_('QWCC001488') }}
			</sf-button>
			<sf-button v-if="isButton_(scrId, 'CU')" line icon="file" :onClick="saveAction">
				{{ getMessage_('MWCC000327') }}
			</sf-button>
			<sf-button v-if="isButton_(scrId, 'CD')" line icon="trash" color="error" :onClick="deleteAction">
				{{ getMessage_('MWCC000328') }}
			</sf-button>
		</template>
	</sf-data-table>
</template>

<script>
import * as yup from 'yup';
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@qms/TabSample/store/helpers';
export default {
	props: { scrId: { type: String, default: '' } },
	data() {
		return {
			addRowData: {
				rowType: 'add',
				permGrpCd: null,
				userGrpName: null,
				useYn: 'Y',
				useYnBk: 'Y',
				prop1: '',
				prop2: '',
				prop3: '',
				prop4: '',
				prop5: '',
				prop6: '',
				prop7: '',
				prop8: '',
				prop9: '',
				prop10: '',
				testTime: '',
				prop12: '',
				prop13: '',
				prop14: '',
				prop15: '',
				prop16: '',
				prop17: '',
				prop18: '',
				prop19: '',
				prop20: ''
			}
		};
	},
	computed: {
		...rootComputed,
		...serviceComputed,
		rows() {
			//console.log('result', this.resultList);
			return this.resultList;
		},
		columns() {
			return [
				{
					label: '품번',
					prop: 'prop2',
					minWidth: '150px',
					type: 'input',
					form: {
						type: 'input',
						maxLength: 100
					}
				},
				{
					label: '품명',
					prop: 'prop3',
					minWidth: '120px',
					type: 'input',
					form: {
						type: 'input',
						maxLength: 100
					}
				},
				{
					label: '유형',
					prop: 'prop4',
					minWidth: '110px',
					form: {
						type: 'select',
						options: this.gridUseYnList
					}
				},
				{
					label: '협력사',
					prop: 'prop5',
					minWidth: '150px',
					sortable: false,
					type: 'input',
					form: {
						type: 'input',
						maxLength: 100
					}
				},
				{
					label: '입고일자',
					prop: 'prop6',
					minWidth: '130px',
					sortable: false,
					type: 'date',
					form: {
						type: 'date',
						maxLength: 100
					}
				},
				{
					label: '입고수량',
					prop: 'prop7',
					minWidth: '100px',
					sortable: false,
					type: 'input',
					form: {
						type: 'input',
						maxLength: 10
					}
				},
				{
					label: '검사번호',
					prop: 'prop8',
					minWidth: '150px',
					sortable: false,
					type: 'input',
					form: {
						type: 'input',
						maxLength: 20
					}
				},
				{
					label: '검사원',
					prop: 'prop9',
					minWidth: '90ox',
					sortable: false,
					type: 'input',
					form: {
						type: 'input',
						maxLength: 12
					}
				},
				{
					label: '검사일자',
					prop: 'prop10',
					minWidth: '130px',
					sortable: false,
					type: 'date',
					form: {
						type: 'date',
						maxLength: 100
					}
				},
				{
					label: '검사시작시간',
					prop: 'testTime',
					minWidth: '120px',
					sortable: false,
					type: 'time',
					custom: true
				},
				{
					label: '검사수행',
					prop: 'prop12',
					minWidth: '90px',
					sortable: false,
					form: {
						type: 'select',
						options: this.gridUseYnList
					}
				},
				{
					label: '불량수량',
					prop: 'prop13',
					minWidth: '80px',
					sortable: false,
					type: 'input',
					form: {
						type: 'number',
						maxLength: 10
					}
				},
				{
					label: '불량통보',
					prop: 'prop14',
					minWidth: '90px',
					form: {
						type: 'select',
						options: this.gridUseYnList
					}
				},
				{
					label: '개선대책',
					prop: 'prop15',
					minWidth: '90px',
					form: {
						type: 'select',
						options: this.gridUseYnList
					}
				},
				{
					label: '상태',
					prop: 'prop16',
					minWidth: '90px',
					form: {
						type: 'select',
						options: this.gridUseYnList
					}
				}
			];
		},
		schema() {
			return yup.array().of(
				yup.object().shape({
					permGrpCd: yup
						.string()
						.nullable()
						.required(this.$sf_formatString(this.getMessage_('MWCC000116'), [this.getMessage_('MWCC000104')])) //{0}은(는) 팔수 입력 값 입니다. , 사용자 권한 그룹 코드
				})
			);
		}
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		async changedPage({ currentPageVal, pageUnitVal, prePage, prePageUnit }) {
			if (!prePage || !prePageUnit) {
				//초기값 셋팅시 이미 searchBar에서 데이터를 조회했기 때문에 중복 조회 하지않도록 처리
				return;
			}
			this.setPagingInfo_({ key: 'currentPage', value: currentPageVal });
			this.setPagingInfo_({ key: 'pageUnit', value: pageUnitVal });
			this.$emit('Refresh');
		},
		resetTable() {
			this.$emit('Refresh');
		},
		isDisabled({ row }) {
			if (row.rowType && row.rowType === 'add') return false;
			else return true;
		},
		addAction() {
			this.rows.unshift(this.addRowData);
			this.$refs.dataTable.getTable().toggleRowSelection(this.addRowData);
		},
		saveAction() {
			const selected = this.$refs.dataTable.getSelectedRows();

			if (!selected.length) {
				this.$sf_showMessage({
					icon: 'error',
					title: this.getMessage_('MWCC000109'),
					message: this.getMessage_('MWCC000110')
				}); //행을 선택해 주세요. / 선택된 데이터가 없습니다.
				return;
			}

			this.$sf_showMessage({
				type: 'confirm',
				icon: 'confirm',
				title: this.getMessage_('MWCC000501'), //저장하시겠습니까?
				buttons: [{ title: this.getMessage_('MWCC000103'), clickFn: () => this.save(selected) }] //저장
			});
		},
		deleteAction() {
			const selected = this.$refs.dataTable.getSelectedRows();

			this.$sf_showMessage({
				type: 'confirm',
				icon: 'confirm',
				title: this.getMessage_('MWCC000108'),
				buttons: [{ title: 'Ok', clickFn: () => this.delete(selected) }]
			});
		},
		delete() {
			let sendData = {
				status: 1,
				plantCd: this.searchParams.plantCd,
				data: []
			};

			const selected = this.$refs.dataTable.getSelectedRows();

			selected.forEach(row => {
				if (row.permGrpCd == null || row.permGrpCd.trim().length < 1) {
					let showMsg1 = this.getMessage_('MWCC000104');
					this.$sf_showMessage({
						title: this.getMessage_('MWCC000415'), // 입력 정보를 확인해주세요.
						message: `<b>${showMsg1}</b> <br/> 필수 입력.`
					});
					return;
				}

				let pushSet = {
					permGrpCd: row.permGrpCd,
					userGrpName: row.userGrpName ? row.userGrpName : '',
					useYn: 'N',
					regId: 'ADMIN',
					chgId: 'ADMIN',
					state: row.tableState
				};
				sendData.data.push(pushSet);
			});

			if (sendData.data.length) {
				this.$sf_toggleLoading(true);
				this.setGroups_(sendData)
					.then(header => {
						if (header.code === 0 || header.code === 3) {
							this.$sf_toast({
								type: header.code === 0 ? 'ok' : 'error',
								message: this.getMessage_(header.messageCd)
							});
						}
						this.resetTable();
					})
					.catch(e => {
						this.$sf_toast({
							type: 'error',
							message: e.message || e
						});
						return e;
					})
					.finally(() => {
						this.$sf_toggleLoading(false);
					});
			}
		},
		save(saveRows) {
			try {
				// 유효성 검사
				this.schema.validateSync(saveRows);

				let sendData = {
					status: 1,
					plantCd: this.searchParams.plantCd,
					data: []
				};

				const selected = this.$refs.dataTable.getSelectedRows();

				selected.forEach(row => {
					// console.log('2');
					let pushSet = {
						permGrpCd: row.permGrpCd,
						userGrpName: row.userGrpName || '',
						useYn: row.useYn || 'Y',
						// regId: this.user.userId,
						// chgId: this.user.userId,
						state: row.tableState
					};
					sendData.data.push(pushSet);
				});

				if (sendData.data.length) {
					// console.log('3');
					this.$sf_toggleLoading(true);
					this.setGroups_(sendData)
						.then(header => {
							if (header.code === 0 || header.code === 3) {
								this.$sf_toast({
									type: header.code === 0 ? 'ok' : 'error',
									message: this.getMessage_(header.messageCd)
								});
							}
							this.resetTable();
						})
						.finally(() => {
							this.$sf_toggleLoading(false);
						});
				}
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error.message });
			}
		},
		saveFunc(saveRows) {
			//console.log(saveRows);
		},
		saveClick() {
			if (this.$refs.dataTable.multipleSelection.length < 1) {
				// title MWCC000110
				this.$sf_showMessage({ title: this.getMessage_('MWCC000110'), message: this.getMessage_('MWCC000434') });
				// message 저장 할 데이터를 선택해주세요.
				return;
			}
			this.$sf_showMessage({
				type: 'confirm',
				message: this.getMessage_('MWCC000501'),
				buttons: [{ title: 'Ok', clickFn: this.save }]
			});
		},
		rowClick(row, column, devent) {
			this.setState_({ key: 'selectedRow', value: row });
		},
		async onClick() {
			//this.$emit('popupOpen', row);
			let item = {
				name: 'test', //this.getMessage_('MWCC000438'), 탭에 표시하기 위한 이름, 다국어: 사이트맵
				component: BlankVue,
				scrId: 'OS10001079',
				msgKey: 'MWCC000438'
			};
			await this.$sf_addTab(item, item.scrId, { scrId: item.scrId });
		}
	}
};
</script>

<style></style>
